var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#445BC7",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 11.3333H11.9999C11.8231 11.3333 11.6535 11.4035 11.5285 11.5285C11.4035 11.6535 11.3333 11.8231 11.3333 11.9999V23.9999C11.3333 24.1767 11.4035 24.3463 11.5285 24.4713C11.6535 24.5963 11.8231 24.6666 11.9999 24.6666H23.9999C24.1767 24.6666 24.3463 24.5963 24.4713 24.4713C24.5963 24.3463 24.6666 24.1767 24.6666 23.9999V11.9999C24.6666 11.8231 24.5963 11.6535 24.4713 11.5285C24.3463 11.4035 24.1767 11.3333 23.9999 11.3333ZM15.3333 23.3333H12.6666V12.6666H15.3333V23.3333ZM23.3333 23.3333H16.6666V18.6666H23.3333V23.3333ZM23.3333 17.3333H16.6666V12.6666H23.3333V17.3333Z",
    fill: "#445BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublication);
export default __webpack_public_path__ + "static/media/publication.0e944bc2622d2492ab48292575cda295.svg";
export { ForwardRef as ReactComponent };